export const getConfigObject = () => {
  return window.config || {};
};

export const getCwUrl = () => {
  const CONFIG = window.config || {};
  const cwApiUrl = CONFIG.CW_SERVICE_URL;
  if (cwApiUrl) return cwApiUrl;

  let cwUrl =
    CONFIG.CW_SERVICES_URL_PREFIX +
    window.location.hostname.split('.').slice(-2).join('.');
  if (CONFIG.CW_SERVICES_URL_PREFIX === 'http://courseware-local.') {
    cwUrl += `:${CONFIG.SERVICES_PORT}`;
  }
  return cwUrl;
};

export const getGBUrl = () => {
  const CONFIG = window.config || {};
  const gbApiUrl = CONFIG.GRADEBOOK_API_URL;
  if (gbApiUrl) return gbApiUrl;

  let gbUrl =
    CONFIG.GRADEBOOK_API_URL_PREFIX +
    window.location.hostname.split('.').slice(-2).join('.');
  if (CONFIG.GRADEBOOK_API_URL_PREFIX === 'http://gradebook-api-local.') {
    gbUrl += `:${CONFIG.GRADEBOOK_PORT}`;
  }
  return gbUrl;
};

export const getDashUrl = () => {
  const CONFIG = window.config || {};
  const dashApiUrl = CONFIG.DASHBOARD_API_URL;
  if (dashApiUrl) return dashApiUrl;

  let dashUrl =
    CONFIG.DASHBOARD_API_URL_PREFIX +
    window.location.hostname.split('.').slice(-2).join('.');
  if (CONFIG.DASHBOARD_API_URL_PREFIX === 'http://dashboard-api-local.') {
    dashUrl += `:${CONFIG.DASHBOARD_PORT}`;
  }
  return dashUrl;
};

export const getIamUrl = () => {
  const CONFIG = window.config || {};
  const { IAM_SERVICE_URL } = CONFIG;

  const iamUrl = IAM_SERVICE_URL || '';
  return iamUrl;
};

export const getIntegrationHubUrl = () => {
  const CONFIG = window.config || {};
  const { AUTHORITY_INTEGRATION_HUB } = CONFIG;

  return AUTHORITY_INTEGRATION_HUB || '';
};

export const setConfigFeatures = (config) => {
  window.config = { ...window.config, ...config };
  // Setup client-side instana
  if (window.config.instanaKey) {
    /* eslint-disable no-unused-expressions */
    (function (c, e, f, k, g, h, b, a, d) {
      c[g] ||
        ((c[g] = h),
        (b = c[h] =
          function () {
            b.q.push(arguments);
          }),
        (b.q = []),
        (b.l = 1 * new Date()),
        (a = e.createElement(f)),
        (a.async = 1),
        (a.src = k),
        a.setAttribute('crossorigin', 'anonymous'),
        (d = e.getElementsByTagName(f)[0]),
        d.parentNode.insertBefore(a, d));
    })(
      window,
      document,
      'script',
      '//eum.instana.io/eum.min.js',
      'InstanaEumObject',
      'ineum',
    );
    /* eslint-disable no-undef */
    ineum('reportingUrl', 'https://eum-us-west-2.instana.io');
    ineum('key', window.config.instanaKey);
  }
};
